import "./publishers.scss";
import Vue from 'vue/dist/vue.esm'
import PublishersApp from './publishers-app.vue'
import ActionCableVue from 'actioncable-vue';

const websocket_protocol = `ws${window.location.protocol === "https:" ? "s" : ""}:`;
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'info',
  connectionUrl: `${websocket_protocol}//${window.location.host}/cable`,
  connectImmediately: true
});

document.addEventListener("DOMContentLoaded", () => {
  Array.from(document.getElementsByClassName("publishers"))
       .forEach(element => {
         const publishers = JSON.parse(element.dataset.publishers);
         new Vue({
                   data: {
                     publishers: publishers,
                   },
                   template: "<PublishersApp :original_publishers='publishers' />",
                   components: {
                     PublishersApp,
                   }
                 }).$mount(element);
       });
});
